import React from 'react';
import { connect } from 'react-redux'
import {Container, Form} from 'react-bootstrap'
import MultipleCuppingCards from '../cuppings/MultipleCuppingCards'
import {CatoroSpinner} from '../CatoroSpinner'
import {fetchSingleUsrTable, getUserTableCuppings, isOwner, updateTable, deleteTable} from '../../actions/actions'
import { Link } from "react-scroll";
import {HorizontalLine} from '../HorizontalLine'
import DisplayError from '../DisplayError'
import { FaEdit } from 'react-icons/fa'
import EditTable from './EditTable'
import { withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { FaFileCsv } from 'react-icons/fa'
import { FaTimesCircle } from 'react-icons/fa';

// import {Tooltip, OverlayTrigger} from 'react-bootstrap'

class TableShow extends React.Component {
    state = {
        showEditTable: false,
        setSort: "num",
        tableCuppingsAndNums: [],
        editIcon: true,
    }

    addCuppingNums = () => {
        const newTableCuppingsAndNums = [].concat(this.props.tableCuppings)
        newTableCuppingsAndNums.forEach(cupping => {
            cupping["cuppingNum"] = newTableCuppingsAndNums.indexOf(cupping) + 1
        })
        this.setState({
            ...this.state,
            tableCuppingsAndNums: newTableCuppingsAndNums
        })
    }

    toggleEdit = () => {
        this.setState({
            ...this.state, 
            showEditTable: !this.state.showEditTable,
            editIcon: !this.state.editIcon
        })
    }

    tableEdit = (table) => {
        // console.log(table)
        window.scrollTo(0, 0);
        this.props.updateTable(table, this.props.singleTable.id)
    }

    renderCsvLink = () => {
        // debugger
        if (this.props.location.state && this.props.location.state.justCreated) {
            return;
        }        
       else if (isOwner(this.props.singleTable.catador_id, this.props.user.id)) {
            let exportTableCuppings = this.props.tableCuppings.map(({id, table_id, created_at, updated_at, ...rest}) => rest)

            return (
                <span className="cog" >
                <CSVLink filename={`${this.props.singleTable.date}CatoroCSVExport_Beta`} data={exportTableCuppings} style={{textDecoration: "none"}}><small style={{color: "#82c91e"}}><FaFileCsv></FaFileCsv></small></CSVLink>&nbsp;&nbsp;</span>
            )
        }
    }

    componentDidMount(){
        window.scrollTo(0, 0);
        const tableId = window.location.pathname.replace("/tables/", "")
        this.props.getUserTableCuppings(tableId)
        this.props.fetchSingleUsrTable(tableId)
    }

     handleDelete = () => {
        window.scrollTo(0, 0);
        this.props.deleteTable(this.props.singleTable.id)
        this.props.history.push("/")
    } 

    componentDidUpdate(prevProps) {
        if (this.props.tableCuppings !== prevProps.tableCuppings) {
            this.addCuppingNums()
        }
    }

    handleSortChange = (event) => {
        this.setState({
        ...this.state,
            setSort: event.target.value,
        })
    } 
    
    sortUserTableCuppings = (dropDown) => {
        if (dropDown === "score") {
            const sortedByScore = [].concat(this.state.tableCuppingsAndNums)
            // debugger
           sortedByScore.sort((a, b) => b.final_score - a.final_score)
           return sortedByScore
       }
   
   }

    filterCuppings = () => {
        // console.log(this.state.setSort)
        if (this.props.tableCuppings.length > 2) {  
          return (
             <Container>
              <Form>
                  <Form.Group controlId="sortTablesT" className="scoreCuppingFormEl sorter w3-center" 
                  style={{margin: "0 auto"}}
                  name="sort"
                  onChange={e => this.handleSortChange(e)} 
                  >
                      <Form.Label>Sort By:</Form.Label>
                      <Form.Control as="select">
                      <option value="num">Cupping No.</option>
                      <option value="score">Highest Score</option>
                      </Form.Control>
                  </Form.Group>
                  <br></br>
               </Form>
           </Container> 
          )
        }
    }

    genJumpTo = () => {
        if (this.props.tableCuppings.length > 1) {
            const hrefCuppings = this.state.tableCuppingsAndNums.map((cupping, index) => 
            <React.Fragment key={cupping.id}> 
                <Link
                className="btn btn-outline-warning btn-sm"
                style={{color: "chocolate"}}
                activeClass="active"
                to={`${cupping.cuppingNum}`}
                spy={true}
                smooth="easeInOutQuint"
                offset={-70}
                duration= {800}
                >{cupping.final_score && cupping.overall? <b style={{color: "goldenrod"}}>✓</b> : index + 1}  </Link> &nbsp;
            </React.Fragment> 
            )
            return (
                <>
                <HorizontalLine color="light-grey" />
                    <p className="w3-center"><span> Progress: </span> &nbsp;
                    {hrefCuppings}</p>
                <HorizontalLine color="light-grey" />
                </>
            )
        }

    } 

    renderEditCog = () => {
        if (isOwner(this.props.singleTable.catador_id, this.props.user.id)) {
            if (this.state.editIcon) {
                return (
                    <span className="cog" >
                        <FaEdit style={{color: "rgb(42, 151, 233)"}} onClick={() => this.toggleEdit()}></FaEdit> 
                    </span>
                )
            } else {
                return (
                    <span className="cog" >
                      <FaTimesCircle className="cog" style={{color: "#f783ac"}} onClick={() => this.toggleEdit()}></FaTimesCircle> 
                    </span>
                )
            }
        }

                /* <OverlayTrigger
                        key="editCog"
                        placement="right"
                        overlay={
                                <Tooltip id={`tooltip-right`}>
                                    Click to edit table
                                </Tooltip>}>
                        <FaEdit style={{color: "rgb(42, 151, 233)"}} onClick={() => this.toggleEdit()}></FaEdit>
                        </OverlayTrigger> */
    }

    returnMultipleCuppings = () => {
        
        // console.log(this.state)
        const owner = isOwner(this.props.singleTable.catador_id, this.props.user.id)
        switch(true) {
        case owner && this.state.setSort === "score":
            const sortedByScore = this.sortUserTableCuppings("score")
            return <MultipleCuppingCards tableCuppings={sortedByScore} isLoggedIn={this.props.isLoggedIn} isOwner={true}/> 
        case owner && this.state.setSort === "num": 
            // debugger
            return (
                <MultipleCuppingCards tableCuppings={this.state.tableCuppingsAndNums} isLoggedIn={this.props.isLoggedIn} isOwner={true}/> 
            )
        case !owner && this.state.setSort === "score":
            const sortedByScoreNon = this.sortUserTableCuppings("score")
            return <MultipleCuppingCards tableCuppings={sortedByScoreNon} isLoggedIn={this.props.isLoggedIn} isOwner={false}/> 
        case !owner && this.state.setSort === "num":
            return (
                <MultipleCuppingCards tableCuppings={this.state.tableCuppingsAndNums} isLoggedIn={this.props.isLoggedIn} isOwner={false}/> 
            )
        default: return;    
        }
    }

    render(){
        if (this.props.error) {
            // console.log(this.props.error_msg)
            return <DisplayError errorMsg={this.props.error_msg} />
        } 
        else if (!this.props.tableCuppings || !this.props.singleTable ) {
            return <CatoroSpinner/>
        }   
        return (
            <React.Fragment>
            <Container className="w3-container">
              <h5 className="styleHeading w3-center"> {this.props.singleTable.catador_name ? this.props.singleTable.catador_name : null} <br></br> <span style={{color: "rgba(251, 77, 61, 1)"}}> {this.props.singleTable.name} ({this.props.singleTable.date}) </span>
              </h5>
            
              <h6 className="w3-center" style={{fontWeight: "bold"}}> {!!this.props.singleTable.public? null : "Private Cupping"} &nbsp; 
              {this.renderCsvLink()}
              {this.renderEditCog()}
              </h6>

              {this.state.showEditTable ? 
                <EditTable table={this.props.singleTable} tableEdit={this.tableEdit} handleDelete={this.handleDelete}/> : null}
                  {this.genJumpTo()}
                  {this.filterCuppings()}
                  {this.returnMultipleCuppings()}
              <br></br>          
            </Container>
           </React.Fragment>
        )  

    }
}

const msp = state => {
	return {
        isLoggedIn: state.users.isLoggedIn,
        user: state.users.user,
        tableCuppings: state.cuppings.tableCuppings,
        singleTable: state.cuppings.singleTable,
        error: state.users.error,
        error_msg: state.users.error_msg,
        table: state.cuppings.table,
        userTables: state.users.userTables,
	}
  };
  
  export default connect(msp, {
    fetchSingleUsrTable, getUserTableCuppings, updateTable, deleteTable,
  })(withRouter(TableShow))